import { matchPath } from "react-router-dom";
import { Route, routes } from "routes";

/**
 * Regex which matches a parameter in the last segment of a path.
 * That is, the last segment of a path should be `/:paramName`.
 * This is exported for testing-use only.
 */
export const paramRegex = /\/:(\w+)/;

/**
 * Gets all the routes for a given path.
 * @param segments
 * @param route
 * @param idx
 * @param acc
 * @returns
 */
export const getRoutesForPath = (
	segments: string[],
	route: Route = routes,
	idx = 0,
	pathAcc: string = "",
	acc: Route[] = [],
): Route[] => {
	//   "/".split("/")
	// The above expression yields:
	//   ["", ""]
	// Therefore, we start processing at the 1st index.
	idx += 1;
	acc.push(route);

	if (idx === segments.length) {
		return acc;
	}

	pathAcc += "/" + segments[idx]!;

	const map = route._;
	if (!map) {
		return acc;
	}

	// Do a linear search for the route
	for (const key in map) {
		if (Object.prototype.hasOwnProperty.call(map, key)) {
			const val = map?.[key];

			if (!val) {
				continue;
			}

			let currIdx = idx;
			let currPathAcc = pathAcc;

			// Check if the last segment of `val.path is a parameter.
			// If it is, then we need to update currIdx and currPathAcc.
			if (paramRegex.test(val.path)) {
				if (currIdx === segments.length) {
					throw new Error(
						`We expected more segments for path ${pathAcc} to match ${val.path}`,
					);
				}

				currIdx = idx + 1;
				currPathAcc += "/" + segments[idx]!;
			}

			if (
				val &&
				matchPath(currPathAcc, {
					path: val.path,
				})
			) {
				return getRoutesForPath(segments, val, currIdx, currPathAcc, acc);
			}
		}
	}

	return acc;
};
